// Shared look for the Marketplace view — same Beacon tokens as the Import Wizard.
export const M = {
  ink: "var(--color-ink)",
  ink2: "rgba(31,22,51,0.75)",
  ink3: "rgba(31,22,51,0.6)",
  ink4: "rgba(31,22,51,0.5)",
  line: "var(--color-hairline-cloud)",
  lineCool: "var(--color-hairline-cool)",
  surface: "var(--color-surface-canvas-light)",
  surface2: "var(--color-surface-press-light)",
  primary: "var(--color-primary)",
  success: "var(--color-success)",
  successBg: "var(--color-success-bg)",
  warn: "var(--color-warn)",
  warnBg: "var(--color-warn-bg)",
  shadowSm: "var(--shadow-card-sm)",
};

export const TYPE_LABELS = { TEST: "Test", SKILL_SHEET: "Skill Sheet", DOCUMENT: "Document", CLASS_TEMPLATE: "Class Template" };

export function fmtFileSize(bytes) {
  if (!bytes) return null;
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/** Turns a listing's `contentSummary` (counts only — see MarketplaceService.summarize) into display lines. */
export function summaryLines(itemType, summary) {
  if (!summary) return [];
  const lines = [];
  if (itemType === "SKILL_SHEET") {
    if (summary.stepCount != null) lines.push(`${summary.stepCount} step${summary.stepCount === 1 ? "" : "s"}${summary.criticalCount ? ` · ${summary.criticalCount} critical` : ""}`);
    if (summary.totalPoints != null) lines.push(`${summary.totalPoints} total pts`);
    if (summary.passingScore != null) lines.push(`Pass score ${summary.passingScore} pts`);
    if (summary.timeLimitMin) lines.push(`${summary.timeLimitMin} min time limit`);
    if (summary.peerAssessmentRequired != null) lines.push(summary.peerAssessmentRequired ? "Peer practice required" : "Peer practice optional");
  } else if (itemType === "TEST") {
    if (summary.questionCount != null) lines.push(`${summary.questionCount} question${summary.questionCount === 1 ? "" : "s"}`);
    if (summary.passingScore != null) lines.push(`Pass score ${summary.passingScore}%`);
    if (summary.timeLimitMin) lines.push(`${summary.timeLimitMin} min time limit`);
  } else if (itemType === "DOCUMENT") {
    if (summary.contentType) lines.push(summary.contentType);
    if (summary.fileName) lines.push(summary.fileName);
  } else if (itemType === "CLASS_TEMPLATE") {
    if (summary.sessionCount != null) lines.push(`${summary.sessionCount} session${summary.sessionCount === 1 ? "" : "s"}`);
  }
  return lines;
}
